import { Button, Card, CardBody, CardHeader, Col, Row } from 'reactstrap';

const CardView = ({ data, isMultiSelectable, schema, currentSelectedBooking, setCurrentSelectedBooking, setCurrentActiveBookingAction }) => {
  console.log('hello card view data', schema);
  return (
    <div className="horizontal-scrollor">
      <div className="booking-data-card-container">
        {data?.map((result, index) => (
          <>
            <Card className={`booking-card ${currentSelectedBooking?.[0]?.id === result?.id ? 'active' : ''}`} key={index}>
              <CardHeader
                className="cursor-pointer d-flex align-items-center gap-2"
                onClick={() => setCurrentSelectedBooking([{ ...result }])}
                style={{ background: 'rgba(233, 235, 236, 1)' }}
              >
                <div
                  style={{
                    display: 'flex',
                    width: '20px',
                    height: '20px',
                    background: currentSelectedBooking?.[0]?.id === result?.id ? 'rgba(64, 81, 137, 1)' : 'rgba(191, 193, 206, 1)',
                    borderRadius: '2px',
                  }}
                >
                  <i className="ri-check-fill m-auto" style={{ color: 'white' }}></i>
                </div>
                <p className="m-0 fs-14 fw-medium" style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  {result?.name || result?.firstName || result?.clientName || ''}
                </p>
              </CardHeader>

              <CardBody className="booking-card-body">
                <Row>
                  {schema?.map((cSchema, index) => {
                    const value = result?.[cSchema?.key];

                    let content = value || 'NA';

                    // Special rendering for status field
                    if (cSchema?.key === 'status') {
                      const status = value?.toLowerCase();
                      let statusClass = 'custom-status-badge-card ';

                      if (status === 'live' || status === 'active') statusClass += 'custom-status-live';
                      else if (status === 'pending') statusClass += 'custom-status-pending';
                      else if (status === 'rejected') statusClass += 'custom-status-rejected';
                      else if (status === 'draft') statusClass += 'custom-status-draft';
                      else if (status === 'approved') statusClass += 'custom-status-approved';
                      else if (status === 'published') statusClass += 'custom-status-published';

                      content = <span className={statusClass}>{value}</span>;
                    }

                    return (
                      <Col md={`${cSchema?.metadata?.widthPercentage === 50 ? 6 : 12}`} className="mb-3" key={index}>
                        <div className="booking-details-heading">{cSchema?.label || '-'}</div>
                        <div className="booking-details-data">{content}</div>
                      </Col>
                    );
                  })}
                </Row>

                <Row>
                  <Col md={12} className="text-center mt-3">
                    <div className="d-flex gap-2 flex-wrap justify-content-center">
                      <>
                        {result?.actions?.includes('update_airport') && (
                          <Button
                            className="customized-btn d-flex align-items-center gap-1"
                            onClick={() => {
                              setCurrentActiveBookingAction('update_airport');
                              setCurrentSelectedBooking([{ ...result }]);
                            }}
                            color="primary"
                          >
                            <i className="ri-edit-line"></i>
                            <span>Edit Details</span>
                          </Button>
                        )}

                        {result?.actions?.includes('update_zone') && (
                          <Button
                            className="customized-btn d-flex align-items-center gap-1"
                            onClick={() => {
                              setCurrentActiveBookingAction('update_zone');
                              setCurrentSelectedBooking([{ ...result }]);
                            }}
                            color="primary"
                          >
                            <i className="ri-edit-line"></i>
                            <span>Edit Details</span>
                          </Button>
                        )}

                        {result?.actions?.includes('update_client') && (
                          <Button
                            className="customized-btn d-flex align-items-center gap-1"
                            onClick={() => {
                              setCurrentActiveBookingAction('update_client');
                              setCurrentSelectedBooking([{ ...result }]);
                            }}
                            color="primary"
                          >
                            <i className="ri-edit-line"></i>
                            <span>Edit Details</span>
                          </Button>
                        )}

                        {result?.actions?.includes('update_vendor') && (
                          <Button
                            className="customized-btn d-flex align-items-center gap-1"
                            onClick={() => {
                              setCurrentActiveBookingAction('update_vendor');
                              setCurrentSelectedBooking([{ ...result }]);
                            }}
                            color="primary"
                          >
                            <i className="ri-edit-line"></i>
                            <span>Edit Details</span>
                          </Button>
                        )}
                      </>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </>
        ))}
      </div>
    </div>
  );
};

export default CardView;
